export function classes(...clss: (string | boolean | undefined)[]): string {
  return clss.filter(Boolean).join(" ");
}
